import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { GetPatientResponse } from '../../responses/orchestrator-telemedicine/get-patient.response';

@Injectable({
    providedIn: 'root'
})

export class PatientAccessService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient,) {
    super();
  }

  public getIdPatientFromGuid(guid: string): Observable<GetPatientResponse>{
    let uri = `PatientAccess/guid/${guid}`;
  
    return this.httpClient.get<GetPatientResponse>(environment.urlApiOrchestratorTelemedicine + uri, this.addHeaderInternalToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}